import { useState, useEffect } from "react"
import styles from "./tournament-hero.module.css"
import { Link } from "react-router-dom"
import { useAuth } from "@/components/context/AuthContext"

export default function TournamentHero() {
  const { user, isAuthenticated } = useAuth();
  const [scrollY, setScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <section className={styles.heroSection}>
      <div className={styles.backgroundContainer}>
        <div
          className={styles.backgroundImage}
          style={{
            backgroundImage:
              "url(/placeholder.webp)",
            transform: `translateY(${scrollY * 0.5}px)`,
          }}
        />
        <div className={styles.overlayGradient} />
        <div className={styles.particlesContainer}>
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={styles.particle}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
              }}
            />
          ))}
        </div>
      </div>

      <div className={styles.heroContent}>
        <div className={styles.badge}>
          <span className={styles.badgeText}>PIXEL MOON ESPORTS</span>
        </div>

        <h1 className={styles.heroTitle}>
          <span className={styles.titleMain}>COMPETE.</span>
          <span className={styles.titleAccent}>CONQUER.</span>
          <span className={styles.titleMain}>COLLECT.</span>
        </h1>

        <p className={styles.heroSubtitle}>
          Join thousands of gamers in epic tournaments. Win real rewards, climb the leaderboard, and prove you're the
          ultimate champion.
        </p>

        <div className={styles.ctaButtons}>
          <Link to={"/tournament/dashboard"}>
            <button className={styles.primaryBtn}>
              Browse Tournaments
              <span className={styles.btnArrow}>→</span>
            </button>
          </Link>
          {isAuthenticated && user?.role === "admin" && (
            <Link to={"/tournament/create"}>
              <button className={styles.secondaryBtn}>Create Tournament</button>
            </Link>
          )}
          <button className={styles.youtubeBtn}>
            <a
              href="https://www.youtube.com/@PixelMoon-v9p"
              target="_blank"
              rel="noopener noreferrer"
              className="flex gap-2 justify-center items-center"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
              Watch Tournaments
            </a>
          </button>
          {/* TODO: enable when feature is finished*/}
          <button
            type="button"
            className={styles.liveBtn}
            disabled
            aria-disabled="true"
            title="Coming soon — will be enabled when feature is finished"
            tabIndex={-1}
            style={{ cursor: "not-allowed" }}
          >
            Live Tournaments (Coming Soon)
          </button>
        </div>

        <div className={styles.heroStats}>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>50K+</span>
            <span className={styles.statLabel}>Active Players</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>₹2.5Cr</span>
            <span className={styles.statLabel}>Prize Pool</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statNumber}>200+</span>
            <span className={styles.statLabel}>Tournaments</span>
          </div>
        </div>
      </div>

      <div className={styles.scrollIndicator}>
        <div className={styles.scrollDot} />
        <span>Scroll to explore</span>
      </div>
    </section>
  )
}
